import { getMetaTag } from '../utils/get-meta-tag';

const bannerDismissedLocalStorageKey = `onesignal-disabled-banner-dismissed`
const bootstrappedAtLocalStorageKey = `push-notification-preferences-bootstrapped-at`

export async function syncOneSignalState(median) {
  const oneSignalUserID = getMetaTag(`onesignal-user-id`)?.content
  if(oneSignalUserID) {
    await median.onesignal.register();
    median.onesignal.login(oneSignalUserID);
    bootstrapNotificationPreferences()
  } else {
    median.onesignal.logout();
  }
}

export async function bootstrapNotificationPreferences() {
  if(!shouldBootstrapPreferences()) { return }
  const notificationPreferenceBootstrapURL = getMetaTag(`notification-preference-bootstrap-url`)?.content
  await fetch(notificationPreferenceBootstrapURL, {method: "PATCH"})
  localStorage.setItem(bootstrappedAtLocalStorageKey, (new Date()).toISOString())
}

function shouldBootstrapPreferences() {
  const value = localStorage.getItem(bootstrappedAtLocalStorageKey)
  if(!value){ return true }
  const currentTime = new Date()
  const lastBootstrappedAt = new Date(value)

  return ((currentTime - lastBootstrappedAt)/(1000 * 60 * 60 * 24)) >= 30.0
}

export async function isSubscribedToOneSignal() {
  const medianInfo = await median.onesignal.info()
  return medianInfo?.subscription?.optedIn
}

export function dismissOneSignalBanner() {
  localStorage.setItem(bannerDismissedLocalStorageKey, "true")
}

export function shouldNotifyThatOneSignalDisabled() {
  return localStorage.getItem(bannerDismissedLocalStorageKey) != "true"
}
